// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participant-navigation {
    position: relative;
    height: 48px;
    z-index: 1000;
}

.participant-navigation.participant-navigation-preview {
    pointer-events: none;
}

.participant-navigation .header-bar {
    cursor: pointer;
    width: 100%;
    height: 100%;
    padding: 8px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
    position: relative;
    background: var(--mdh-background-color-0);
    border-bottom: solid 1px var(--mdh-border-color-1);
}

.participant-navigation .menu-dropdown {
    position: absolute;
    top: calc(100% - 1px);
    right: 0;
    background: var(--mdh-background-color-0);
    z-index: 3;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .2);
    max-width: 500px;
    width: 100%;
}

.participant-navigation .menu-dropdown .menu-section .menu-section-header {
    font-size: 13px;
    color: var(--mdh-text-color-2);
    margin-top: 16px;
    margin-bottom: 8px;
    font-weight: 600;
    margin-left: 16px;
}


.participant-navigation .menu-dropdown .menu-item {
    padding: 8px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    cursor: pointer;
    color: var(--mdh-text-color-1);
    border-bottom: solid 1px var(--mdh-border-color-1);
    width: 100%;
    box-sizing: border-box;
}

.participant-navigation .menu-dropdown .menu-item:hover,
.participant-navigation .menu-dropdown .menu-item.selected {
    background: var(--mdh-background-color-1);
}

.participant-navigation .menu-dropdown .menu-item .app-download-image {
    height: 24px;
}

.participant-navigation .selected-project {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: bold;
    width: calc(100% - 32px);
}

.participant-navigation .menu-item-component {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 24px;
}

.participant-navigation .menu-item-component:first-child {
    width: 100%;
}

.participant-navigation .menu-item-component .badge {
    background: #ea4e3d;
    color: var(--mdh-background-color-0);
    text-align: center;
    font-size: 13px;
    height: 18px;
    border-radius: 11px;
    min-width: 9px;
    padding-left: 4.5px;
    padding-right: 4.5px;
    line-height: 18px;
    margin-right: 6px;
    color: #FFF;
}

.participant-navigation .menu-item-component svg {
    width: 24px;
}


.participant-navigation .menu-item-component .tab-icon {
    width: 24px;
    text-align: center;
}

.participant-navigation .open-button {
    position: relative;
    height: 24px;
    width: 24px;
    text-align: center;
    line-height: 25px;
    color: #333;
}

.color-scheme-dark .open-button {
    color: #FFF;
}

.participant-navigation .open-button .badge {
    position: absolute;
    background: #ea4e3d;
    color: #FFF;
    text-align: center;
    font-size: 13px;
    right: calc(50% - 24px);
    top: -8px;
    height: 18px;
    border-radius: 11px;
    min-width: 9px;
    padding-left: 4.5px;
    padding-right: 4.5px;
    line-height: 18px;
    border: solid 2px #FFF;
}

.participant-navigation .project-image-container {
    padding: 2px;
    border-radius: 4px;
    background-color: #FFF;
}

.participant-navigation .project-image {
    width: 24px;
    height: 24px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 4px;
}

.participant-navigation .project-wide-logo {
    height: 24px;
}

.participant-navigation .project-name {
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.participant-navigation .menu-overlay {
    background: var(--mdh-background-color-inverted);
    opacity: .5;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
}

.participant-navigation .menu-overlay-blur {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    backdrop-filter: blur(2px);
}

.participant-navigation .mydatahelps-brand {
    text-align: center;
    padding: 16px;
}

.participant-navigation .mydatahelps-brand img {
    height: 24px;
}

.color-scheme-dark .participant-navigation .menu-dropdown {
    box-shadow: 0 1px 2px 0 rgba(255, 255, 255, .2);
}

.participant-navigation .language-select {
    flex-grow: 1;
    padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/MyDataHelps/ParticipantNavigation/ParticipantNavigation.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yCAAyC;IACzC,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,yCAAyC;IACzC,UAAU;IACV,yCAAyC;IACzC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,eAAe;IACf,8BAA8B;IAC9B,kDAAkD;IAClD,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".participant-navigation {\n    position: relative;\n    height: 48px;\n    z-index: 1000;\n}\n\n.participant-navigation.participant-navigation-preview {\n    pointer-events: none;\n}\n\n.participant-navigation .header-bar {\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n    padding: 8px;\n    padding-left: 16px;\n    padding-right: 16px;\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 2;\n    position: relative;\n    background: var(--mdh-background-color-0);\n    border-bottom: solid 1px var(--mdh-border-color-1);\n}\n\n.participant-navigation .menu-dropdown {\n    position: absolute;\n    top: calc(100% - 1px);\n    right: 0;\n    background: var(--mdh-background-color-0);\n    z-index: 3;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .2);\n    max-width: 500px;\n    width: 100%;\n}\n\n.participant-navigation .menu-dropdown .menu-section .menu-section-header {\n    font-size: 13px;\n    color: var(--mdh-text-color-2);\n    margin-top: 16px;\n    margin-bottom: 8px;\n    font-weight: 600;\n    margin-left: 16px;\n}\n\n\n.participant-navigation .menu-dropdown .menu-item {\n    padding: 8px;\n    padding-left: 16px;\n    padding-right: 16px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    justify-content: space-between;\n    text-decoration: none;\n    cursor: pointer;\n    color: var(--mdh-text-color-1);\n    border-bottom: solid 1px var(--mdh-border-color-1);\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.participant-navigation .menu-dropdown .menu-item:hover,\n.participant-navigation .menu-dropdown .menu-item.selected {\n    background: var(--mdh-background-color-1);\n}\n\n.participant-navigation .menu-dropdown .menu-item .app-download-image {\n    height: 24px;\n}\n\n.participant-navigation .selected-project {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: bold;\n    width: calc(100% - 32px);\n}\n\n.participant-navigation .menu-item-component {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 24px;\n}\n\n.participant-navigation .menu-item-component:first-child {\n    width: 100%;\n}\n\n.participant-navigation .menu-item-component .badge {\n    background: #ea4e3d;\n    color: var(--mdh-background-color-0);\n    text-align: center;\n    font-size: 13px;\n    height: 18px;\n    border-radius: 11px;\n    min-width: 9px;\n    padding-left: 4.5px;\n    padding-right: 4.5px;\n    line-height: 18px;\n    margin-right: 6px;\n    color: #FFF;\n}\n\n.participant-navigation .menu-item-component svg {\n    width: 24px;\n}\n\n\n.participant-navigation .menu-item-component .tab-icon {\n    width: 24px;\n    text-align: center;\n}\n\n.participant-navigation .open-button {\n    position: relative;\n    height: 24px;\n    width: 24px;\n    text-align: center;\n    line-height: 25px;\n    color: #333;\n}\n\n.color-scheme-dark .open-button {\n    color: #FFF;\n}\n\n.participant-navigation .open-button .badge {\n    position: absolute;\n    background: #ea4e3d;\n    color: #FFF;\n    text-align: center;\n    font-size: 13px;\n    right: calc(50% - 24px);\n    top: -8px;\n    height: 18px;\n    border-radius: 11px;\n    min-width: 9px;\n    padding-left: 4.5px;\n    padding-right: 4.5px;\n    line-height: 18px;\n    border: solid 2px #FFF;\n}\n\n.participant-navigation .project-image-container {\n    padding: 2px;\n    border-radius: 4px;\n    background-color: #FFF;\n}\n\n.participant-navigation .project-image {\n    width: 24px;\n    height: 24px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center center;\n    border-radius: 4px;\n}\n\n.participant-navigation .project-wide-logo {\n    height: 24px;\n}\n\n.participant-navigation .project-name {\n    font-size: 14px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.participant-navigation .menu-overlay {\n    background: var(--mdh-background-color-inverted);\n    opacity: .5;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n}\n\n.participant-navigation .menu-overlay-blur {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n    backdrop-filter: blur(2px);\n}\n\n.participant-navigation .mydatahelps-brand {\n    text-align: center;\n    padding: 16px;\n}\n\n.participant-navigation .mydatahelps-brand img {\n    height: 24px;\n}\n\n.color-scheme-dark .participant-navigation .menu-dropdown {\n    box-shadow: 0 1px 2px 0 rgba(255, 255, 255, .2);\n}\n\n.participant-navigation .language-select {\n    flex-grow: 1;\n    padding: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
